import { render, staticRenderFns } from "./CustomerLedger.vue?vue&type=template&id=3554fa50&"
import script from "./CustomerLedger.vue?vue&type=script&lang=js&"
export * from "./CustomerLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports